import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';

// MUI
import { Search } from '@mui/icons-material';
import { Box, IconButton, InputAdornment, TextField } from '@mui/material';

// Styles
import './GlobalSearch.scss';

// Services
import AuthService from '../../../services/auth.service';
import { getEnvLabel } from '../../../helpers/determine-env';
import { getDeviceBySerialNumber } from '../../../services/device.service';

const GlobalSearch = () => {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean>(false);
  const [searchValue, setSearchValue] = useState<string>('');
  const [notPairedMessage, setNotPairedMessage] = useState<string | null>(null);

  const envLabel = getEnvLabel();
  const navigate = useNavigate();

  const isExternalUser = AuthService.getStoredUserProfile()?.isInternal === false;

  useEffect(() => {
    AuthService.isAuthenticated().then((x) => setIsAuthenticated(x));
  }, []);

  const search = async () => {
    const value = searchValue.trim();
    if (!value) return;

    if (isExternalUser) {
      try {
        const result = await getDeviceBySerialNumber(value);
        if (result.results.at(0)) {
          navigate(`/visits/${value}?bySerial=true`);
          return;
        }
      } catch (err) {
        console.error('Serial number lookup failed:', err);
      }
    }

    navigate(`/search/${value}`);
  };

  return (
    <>
      {envLabel && <Box className='sidebar-env-badge'>{envLabel}</Box>}
      {isAuthenticated && (
        <Box className='global-search' display='flex'>
          <TextField
            className='global-search-textfield'
            value={searchValue}
            size='small'
            placeholder='Search...'
            onChange={(x) => {
              setSearchValue(x.target.value);
              if (notPairedMessage) setNotPairedMessage(null);
            }}
            onKeyUp={(e) => {
              if (e.key === 'Enter') search();
            }}
            error={!!notPairedMessage}
            helperText={notPairedMessage ?? ''}
            InputProps={{
              endAdornment: (
                <InputAdornment position='end' className='global-search-end-icon'>
                  <IconButton className='global-search-icon-button' onClick={() => search()}>
                    <Search sx={{ fontSize: 18 }} />
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        </Box>
      )}
    </>
  );
};

export default GlobalSearch;
